import { render } from "./DIcon.vue?vue&type=template&id=93571144&scoped=true"
import script from "./DIcon.vue?vue&type=script&lang=js"
export * from "./DIcon.vue?vue&type=script&lang=js"

import "./DIcon.vue?vue&type=style&index=0&id=93571144&scoped=true&lang=css"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93571144"]])

export default __exports__